import { Typography } from "@mui/material";
import moment from "moment";
import * as React from "react";
import { t } from "../../../components/translate";
import { CalendarFunctions as calFns, CalendarData as calData } from "../../../components/Calendar";
import styles from "./topbar.module.scss";

const today = new Date();

const DateShow = (): React.JSX.Element => (
  <div className={styles.date}>
    <Typography fontWeight="normal" variant="h6">
      {`${calFns.convertADtoBS(today).formatted5}, ${calData.bsDaysFull(t)[moment(today).day()]}`}
    </Typography>
    <Typography fontWeight="normal" variant="h6">
      {moment(today).format("Do MMMM YYYY")}
    </Typography>
  </div>
);

export default DateShow;
